import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';

import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';

export const usageReportsStateSlice = getCachedTableStateSlice<
    undefined,
    undefined,
    undefined
>('usageReportsState', undefined, {currentPage: 1, pageSize: 10});

export const usageReportsStateActions = usageReportsStateSlice.actions;
export const usageReportsStateSelector: CachedTableStateSelector<
    undefined,
    undefined,
    undefined
> = state => state.accountPage.tabs.licenseAndFeatures.reports.usageReport.state;
